import React, { Component } from 'react';
import { Modal, Button, message } from 'antd';
import FormList from '../../basicElement/FormList';
import ExportUtil from '../../../common/ExportUtil';
import $ from "../../../common/AjaxRequest";
import API_URL from '../../../common/url';

class Update extends Component {
    state = {
        data: {},
        list: [],
        canEdit: false,  // true为未申请 false未已申请
        loading: false,
        invPauseReason:[],
        invPauseInfo:[]
    }

    componentDidMount() {
        const { data } = this.props;
        this.loadData(data);
        this.queryInvPauseInfo();
        this.queryInvPauseReason();
    }

    componentWillReceiveProps(nextProps) {
        const { data } = nextProps;
        this.loadData(data);
    }

    loadData = (data) => {
        const { jdeApplyId, invTerminationApplyId } = data;
        const canEdit = !jdeApplyId && !invTerminationApplyId;
        this.setState({
            data,
            canEdit,
        }, () => {
            this.loadContractFile();
        });
    }

    queryInvPauseReason = () => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryByParams,
            data: {typeName:'INVESTIGATION_TERMINATION_PAUSE_REASON'},
            dataType: 'json',
            doneResult: res => {
                const { typeConfigureList } =res
                this.setState({invPauseReason:typeConfigureList})
            }
        };
        $.sendRequest(options);
    }

    queryInvPauseInfo = () => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryByParams,
            data: {typeName:'INVESTIGATION_TERMINATION_PAUSE_INFO'},
            dataType: 'json',
            doneResult: res => {
                const { typeConfigureList } =res
                this.setState({invPauseInfo:typeConfigureList})
            }
        };
        $.sendRequest(options);
    }

    loadContractFile = () => {
        const { data: { jdeApplyId } } = this.state;
        if (!jdeApplyId) return;

        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeApplyFileMetaById,
            data: {
                jdeApplyId,
                uploadType: 'CONTRACT',
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = this.state;
                data.fileList.splice(data.fileList.length, 0, ...res.data);
                this.setState({
                    data,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    getFileList = (fileList) => fileList.map(i => <a key={i.fileMateId} onClick={e => this.downLoadFile(e, i.fileMateId)}>{i.name}<br/></a>)

    handleChange = (value, key, type) => {
        const { data } = this.state;
        data[key] = value;
        this.setState({ data });
    }

    getColumns = () => {
        const { canEdit, data , invPauseInfo ,invPauseReason} = this.state;
        const { jdeApplyStatusShow, applyUserName, applyUserCode, jdeApplyUserName, jdeApplyUserCode } = data;
        const invPauseInfoOption = invPauseInfo.map(i => ({ label: i.typeValue, value: i.typeConfigureId}));
        const invPauseReasonOption = invPauseReason.map(i => ({ label: i.typeValue, value: i.typeConfigureId}));

        // 字段属性配置
        const columns = [{
            name: '申请项目终止时间',
            key: 'terminationTime',
            type: 'datePicker',
            typeProperty: {
                style: { width: 200 },
            },
            rules: {
                required: true,
            }
        }, {
            name: '合同额含税/人民币',
            key: 'jdeContractAmount',
            type: 'text',
            typeProperty: {
                unit: '元',
            },
            rules: {
                format: (value) => {
                    return (value || value === 0) ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
                }
            },
        },{
            name: '项目终止情况',
            key: canEdit?'investigationPauseInfoId':'investigationPauseInfo',
            type: 'select',
            typeProperty: {
                style: {width: 300},
                list: invPauseInfoOption
            },
            rules: {
                required: true,
            },
        },{
            name: '项目终止原因',
            key: canEdit?'investigationPauseReasonId':'investigationPauseReason',
            type: 'select',
            typeProperty: {
                style: {width: 300},
                list: invPauseReasonOption
            },
            rules: {
                required: true,
            },
        }, ];
        if(data.investigationPauseReasonId == 147 && canEdit){
            columns.push({
                key: 'terminationReason',
                type: 'input',
                typeProperty: {
                    style: { width: 300 },
                    placeholder:'其他原因说明'
                },
                rules: {
                    colon:false,
                    required: false,
                },
            })
        }
        columns.push(
            {
                name: '相关凭证/合同附件',
                key: 'fileList',
                type: 'upload',
                typeProperty: {
                    params: {
                        relateId: '',
                        path: Date.now(),
                        uploadType: 'INV_TERMINATION_APPLY',
                    },
                    uploadUrl: API_URL.proContract.uploadJdeCodeEnclosure,
                    removeUrl: API_URL.proContract.deleteJdeCodeEnclosure,
                },
            }
        )

        if (!canEdit) {
            columns.push({
                name: '项目终止申请人',
                key: 'applyUser',
                type: 'text',
            }, {
                name: 'JDE建号申请状态',
                key: 'jdeApplyStatusShow',
                type: 'text',
            });
            if (jdeApplyStatusShow != '未申请') {
                columns.push({
                    name: 'JDE建号申请人',
                    key: 'jdeApplyUser',
                    type: 'text',
                }, {
                    name: '合同开始时间',
                    key: 'contractStartDate',
                    type: 'datePicker',
                }, {
                    name: '合同结束时间',
                    key: 'contractEndDate',
                    type: 'datePicker',
                });
            }
        }

        // 字段值、显示状态配置
        const traverseColumns = (columns) => {
            columns.forEach(column => {
                const { key, type, rules = {} } = column;
                const typeProperty = column.typeProperty || (column.typeProperty = {});
                typeProperty.canEdit = canEdit;
                if (!canEdit) {
                    if (type === 'datePicker') {
                        const value = data[key];
                        typeProperty.value = value ? value.slice(0, 10) : '';
                    } else if (type === 'upload') {
                        typeProperty.value = this.getFileList(data[key] || []);
                    } else {
                        if (key === 'applyUser') {
                            typeProperty.value = applyUserName ? `${applyUserName}[${applyUserCode}]` : '';
                        } else if (key === 'jdeApplyUser') {
                            typeProperty.value = `${jdeApplyUserName}[${jdeApplyUserCode}]`;
                        } else {
                            typeProperty.value = data[key];
                        }
                    }
                    if (rules.hasOwnProperty('required')) {
                        rules.required = false;
                    }
                } else {
                    typeProperty.value = data[key];
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    cancel = () => {
        Modal.confirm({
            title: '确认撤销该项目的终止申请?',
            onOk: () => {
                const { data } = this.state;
                const { invTerminationApplyId } = data;
                this.setState({ loading: true });
                const options = {
                    method: 'POST',
                    url: API_URL.proContract.cancelInvTerminationApply,
                    data: { invTerminationApplyId },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.setState({
                            loading: false,
                        }, () => {
                            this.props.loadData();
                        });
                    },
                    errorResult: () => {
                        this.setState({ loading: false });
                    }
                }
                $.sendRequest(options);
            }
        });
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        Modal.confirm({
            title: '确认提交该项目的终止申请?',
            onOk: () => {
                this.save();
            }
        });
    }

    save = () => {
        const { data } = this.state;
        const { 
            terminationTime, 
            fileList , 
            investigationPauseInfoId,
            investigationPauseReasonId,
        } = data;
        let {terminationReason} = data;
        const files = {};
        if (fileList.length) {
            fileList.forEach((item, index) => {
                files[`ids[${index}]`] = item.response.fileMetaId;
            });
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.proContract.addInvTerminationApply,
            data: {
                terminationTime,
                terminationReason,
                ...files,
                investigationPauseInfoId,
                investigationPauseReasonId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    render() {
        const { canEdit, data } = this.state;
        const { curRole } = sessionStorage;
        const { jdeApplyStatusShow } = data;
        return (
            <div style={{ marginTop: 10 }}>
                <FormList
                    className="form-list"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
                {
                    canEdit ?
                        <div style={{ margin: '8px 0', paddingTop: 10, textAlign: 'center', borderTop: '1px solid #f1f1f1' }}>
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={() => this.props.changeShowTips(true)}
                            >取消</Button>
                            <Button
                                type="primary"
                                onClick={this.confirm}
                            >保存并提交申请</Button>
                        </div>
                    :
                        curRole === 'PM' && jdeApplyStatusShow === '未申请' &&
                            <div style={{ margin: '8px 0', paddingTop: 10, textAlign: 'center', borderTop: '1px solid #f1f1f1' }}>
                                <Button
                                    type="primary"
                                    onClick={this.cancel}
                                >撤销项目终止申请</Button>
                            </div>
                }
            </div>
        );
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/projectContract/terminationApply/Update.js